import BotTemplateCollections from "@components/BotTemplateCollections";
import BotTemplatePage from "@components/BotTemplatePage";
import axios from "axios";
import { BotTemplateCollectionResult, BotTemplateData, BotTemplatePageResult, Params } from "../../types/wa-chatbot-templates";

// ------------ get categories -------------
const getCategories = async (): Promise<string[] | undefined> => {
    const apiKey = process.env.REACT_APP_API_KEY;
    const apiSecret = process.env.REACT_APP_API_SECRET;

    let categories;
    await axios({
        method: "get",
        url: "https://server.gallabox.com/devapi/bot-templates/categories",
        headers: {
            apiSecret: apiSecret,
            apiKey: apiKey,
        },
    })
        .then(function (response) {
            categories = JSON.parse(JSON.stringify(response.data));
        })
        .catch(function (err) {
            categories = JSON.parse(JSON.stringify(err));
        });
    return categories;
};

interface BotTemplateProps {
    data: BotTemplatePageResult | BotTemplateCollectionResult;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, react/prop-types
const BotTemplate = (props: BotTemplateProps) => {
    const { data } = props;
    if (data.slug?.length === 2) {
        return <BotTemplatePage data={data as BotTemplatePageResult} />;
    }

    return <BotTemplateCollections inputData={data as BotTemplateCollectionResult} />;
};
export default BotTemplate;

interface ServerSidePropsArgs {
    params: Params;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export async function getServerSideProps({ params }: ServerSidePropsArgs) {
    try {
        let category = "";
        let slugVal = [];
        if (params.slug.length === 3) {
            category = params.slug[0];
            slugVal = [params.slug[1], params.slug[2]];
        } else {
            slugVal = params.slug;
        }
        let result;
        await axios({
            method: "get",
            url: `https://server.gallabox.com/devapi/bot-templates${slugVal?.length === 2 ? `/${slugVal[1]}` : ""}`,
            headers: {
                apiSecret: process.env.REACT_APP_API_SECRET,
                apiKey: process.env.REACT_APP_API_KEY,
            },
            data: {
                status: "published",
                limit: 100,
                category: slugVal[0].replace("-", " "),
            },
        }).then(function (response) {
            result = JSON.parse(JSON.stringify(response?.data || null));
        });

        const categoriesList = await getCategories();

        let relatedTemplates: BotTemplateData[] = [];
        await axios({
            method: "get",
            url: "https://server.gallabox.com/devapi/bot-templates",
            headers: {
                apiSecret: process.env.REACT_APP_API_SECRET,
                apiKey: process.env.REACT_APP_API_KEY,
            },
            data: {
                status: "published",
                category: slugVal[0],
            },
        }).then(function (response) {
            if (Array.isArray(response.data)) relatedTemplates = JSON.parse(JSON.stringify(response.data));
        });

        let otherTemplates: BotTemplateData[] = [];
        if (relatedTemplates?.length < 3) {
            const anotherCategory = categoriesList?.[0]?.toLowerCase() === slugVal[0] ? categoriesList[1] : categoriesList?.[0];
            await axios({
                method: "get",
                url: "https://server.gallabox.com/devapi/bot-templates",
                headers: {
                    apiSecret: process.env.REACT_APP_API_SECRET,
                    apiKey: process.env.REACT_APP_API_KEY,
                },
                data: {
                    status: "published",
                    category: anotherCategory,
                },
            }).then(function (response) {
                otherTemplates = JSON.parse(JSON.stringify(response?.data || null));
            });
        }

        return {
            props: {
                data: {
                    res: result,
                    slug: slugVal,
                    category,
                    categories: ["Ecommerce", "Healthcare", "Automobile", "Education", "Popular", "All", "Travel", "Real Estate"],
                    relatedData: [...relatedTemplates, ...otherTemplates],
                },
            },
        };
    } catch (err) {
        console.log(JSON.stringify(err));
        return {
            redirect: {
                destination: "/404",
                permanent: false,
            },
        };
    }
}
